var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3648 12.8623V15.4565L13.6917 13.1854L14.0791 8.68726L21.3648 12.8623Z",
    stroke: "#040000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63489 15.4565V12.8623L9.92064 8.68726L10.3084 13.1854L2.63489 15.4565Z",
    stroke: "#040000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8693 19.6743C10.9309 20.2524 11.4162 20.6937 12.0001 20.6937C12.5839 20.6937 13.0692 20.2524 13.1309 19.6743L16.6828 21.7097V23.0068L12.0001 21.621L7.31799 23.0068V21.7097L10.8693 19.6743Z",
    stroke: "#040000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.993408C13.4746 0.993408 14.6332 2.2563 14.5065 3.72544L14.0791 8.68725L13.6913 13.1854L13.1342 19.6526C13.1335 19.6601 13.1308 19.6668 13.1301 19.6743C13.0685 20.2524 12.5832 20.6937 11.9993 20.6937C11.4155 20.6937 10.9302 20.2524 10.8685 19.6743C10.8679 19.6668 10.8655 19.6601 10.8648 19.6526L10.3074 13.1854L9.91958 8.68725L9.4932 3.72544C9.36688 2.2563 10.5251 0.993408 12 0.993408Z",
    stroke: "#040000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.291e303938a572218d74e5171b04e396.svg";
export { ForwardRef as ReactComponent };